module.exports = __webpack_public_path__ + "static/media/006_Bitmap.e117ea95.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/redboxinstant/006_Bitmap.png
// module id = 613
// module chunks = 0